import React from 'react';
import { dbDateToTimestamp, parseEntities, parseDateToneelmakerij } from '../../utils/helpers';

const Card = ({ element, setTagsParam, config }) => {

	return (
		<a className="add-focus" href={element.permalink}>
			<div className="add-focus tile">
				<div className="add-focus tile__date-time">
					<h2 className="add-focus tile__time h5 subheader" >{`${element.times[0].program_start.substring(8, 10)}:${element.times[0].program_start.substring(10, 12)} \u00A0`}</h2>
					<time
						dateTime={new Date(dbDateToTimestamp(element.times[0].program_start))}
						className="agenda-card__date"
					>
							<h2 className="tile__date h5">{parseDateToneelmakerij(dbDateToTimestamp(element.times[0].program_start))}</h2>{' '}
					</time>
				</div>
				<div className="tile__content">
				<div className="tile__content-text">
					<h2 className="tile__title h5">{parseEntities(element.title)}</h2>
					<div className="tile__details">
						<p className="tile__tag icon-b">{Object.keys(element.tags?.classification)[0]}</p>
						<p className="tile__city"> {Object.values(element.times[0].location)[0]}</p>
						<p className="tile__location ">{Object.values(element.times[0].room)[0]}</p>
						<p className="tile__extra">{Object.values(element.times[0].extra)[0]}</p>
					</div>
				</div>
				<div className="tile__btn-container">
					{ element.times[0].ticket_link
						?
						<div className="btn-outer">
								<a href={element.times[0].ticket_link} className="btn btn--ticket">
									<span className="btn__text subheader">{element.times[0].status_label}</span>
								</a>
						</div>
						:
							<button href="" className="btn btn--school-play">
								<span className="btn__text subheader">{element.times[0].status_label}</span>
							</button>
					}
				</div>

				</div>
				<div className="tile__img-container">
					<img src={element.poster_mobile ? element.poster_mobile : element.poster_desktop} alt="" className="agenda-card__img" />
				</div>

			</div>
		</a>
	);
};

export default Card;
